import styled from 'styled-components';

export const AttributesContainer = styled.section`
  margin-top: 2rem;
`;

export const ItemsAmountRow = styled.div`
  padding-top: 30px;
`;
